import Button from "@mui/material/Button";
import { MicrosoftLogo } from "./MicrosoftLogo";
import { useState } from "react";
import { Box, Tooltip } from "@mui/material";

const SIGNIN_MICROSOFT_URL: string = import.meta.env.VITE_SIGNIN_MICROSOFT_URL;

export function SignInWithMicrosoft() {
  const [loading, setLoading] = useState(false);

  async function handleSignInClick() {
    setLoading(true);
  }

  return (
    <>
      <Tooltip title="Em desenvolvimento" placement="bottom">
        <Box>
          <Button
            href={SIGNIN_MICROSOFT_URL}
            startIcon={<MicrosoftLogo />}
            onClick={handleSignInClick}
            size="large"
            variant="contained"
            disabled
            style={{
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              color: "#2F4858",
              flex: 1,
              width: "100%",
            }}
          >
            {loading
              ? "Redirecionando para o Microsoft..."
              : "Entrar com Microsoft"}
          </Button>
        </Box>
      </Tooltip>
    </>
  );
}

export default SignInWithMicrosoft;
